module.exports = __webpack_public_path__ + "img/information_message_of_love@2x.82c369c.webp";